<template>
  <div v-if="instagramLinked==true">
    <div v-if="postAnalyticsData != null">
      <div v-if="insightsLoaded == true">
        <div class="row">
          <div class="col-md-12">
            <p-button outline type="info" size="sm" round @click="$router.go(-1)">
              <i class="fa fa-chevron-circle-left"></i>
              Back
            </p-button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h4 style="margin:0px;margin-top:25px;">@{{$route.params.instagram}} Content Performance</h4>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <div style="padding: 10px;float:left;">
                  Starting
                  <datepicker
                    v-model="pickerStart"
                    placeholder="Select Date:"
                    name="datStart"
                    input-class="calendar-input-analytics"
                    format="M/d/yy"
                    :use-utc="true"
                  ></datepicker>
                </div>
                <div style="padding:10px;float:left;">
                  Ending
                  <datepicker
                    v-model="pickerEnd"
                    placeholder="Select Date:"
                    name="campaignStart"
                    input-class="calendar-input-analytics"
                    format="M/d/yy"
                    :use-utc="true"
                  ></datepicker>
                </div>
                <div style="padding: 10px; margin-top:10px;float:left;">
                  <p-button color="success" class="mr-4" @click="resetDates">Select</p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="insightsLoaded == true"></div>

      <div v-if="postAnalyticsData.postTypes.feed.summary.posts > 0">
        <div class="row" style="clear:both;">
          <div class="col-md-12">
            <div class="row" style="clear:both;">
              <div class="col-md-5">
                <h5
                  style="margin:0px; padding: 0px;"
                  class="analytics-section-title"
                >Feed Performance</h5>
              </div>
              <div class="col-md-7">
                <p-button
                  type="info"
                  round
                  outline
                  size="sm"
                  style="margin:0px; float:right;"
                  @click="fullFeedAnalyticsButton"
                >
                  FULL FEED REPORT
                  <i class="fas fa-angle-right"></i>
                </p-button>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fab fa-instagram"
              small-title="Posts"
              :title="feedAnalyticsData.postCount"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fas fa-users"
              small-title="Avg Reach"
              :title="feedAnalyticsData.avgReach"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-eye"
              small-title="Avg Imp"
              :title="feedAnalyticsData.avgImpressions"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fas fa-eye"
              small-title="Total Imp"
              :title="feedAnalyticsData.totalImpressions"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fas fa-chart-line"
              small-title="ER"
              :title="feedAnalyticsData.avgEngagementRate+ '%'"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-heart"
              small-title="Avg Likes"
              :title="feedAnalyticsData.avgLikes"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-comment"
              small-title="Avg Comments"
              :title="feedAnalyticsData.avgComments"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-bookmark"
              small-title="Avg Saves"
              :title="feedAnalyticsData.avgSaves"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
        </div>
      </div>

      <div v-if="postAnalyticsData.postTypes.stories.summary.posts > 0">
        <div class="row" style="clear:both;">
          <div class="col-md-12">
            <h5 class="analytics-section-title">Story Performance</h5>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fab fa-instagram"
              small-title="Posts"
              :title="storyAnalyticsData.postCount"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fas fa-users"
              small-title="Avg Reach"
              :title="storyAnalyticsData.avgReach"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="far fa-eye"
              small-title="Avg Imp"
              :title="storyAnalyticsData.avgImpressions"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <stats-card
              type="primary"
              icon="fas fa-eye"
              small-title="Total Imp"
              :title="storyAnalyticsData.totalImpressions"
            >
              <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
              </div>-->
            </stats-card>
          </div>
        </div>
      </div>

      <div class="row" style="display:none;">
        <div class="col-md-6" v-if="hashtagGeneralChart !== null">
          <card style="padding-bottom:35px;">
            <template slot="header">
              <p class="card-category">Hashtag Performance</p>
            </template>
            <apexchart
              width="445"
              type="bar"
              :options="hashtagGeneralChart.options"
              :series="hashtagGeneralChart.series"
            ></apexchart>
          </card>
        </div>
        <div class="col-md-6" v-if="hashtagRankedChart !== null">
          <card>
            <template slot="header">
              <p class="card-category">Top Ranked Hashtags</p>
            </template>
            <apexchart
              width="500"
              type="bar"
              :options="hashtagRankedChart.options"
              :series="hashtagRankedChart.series"
            ></apexchart>
          </card>
        </div>
      </div>

      <div class="row" v-if="mentionPostList.length >0">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header" style="padding-bottom:0px; margin-bottom:0px;">
              <div>
                <h5 class="title" style="padding-bottom:0px;  margin-bottom:0px;">Recent Tags</h5>
                <hr />
              </div>

              <div style="top: 0px; right: 10px; position:absolute; ">
                <p-button
                  style="margin-top:15px;"
                  type="info"
                  @click="$router.push(`/instagram/content/${activeInstagram}/?view=mentions`)"
                  link
                >view all</p-button>
              </div>
            </div>

            <div class="card-body">
              <div class="post-preview" v-for="post in mentionPostList" :key="post.shortcode">
                <span v-if="post.cached == true">
                  <img
                    :src="post.imageUrlCache"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/content/${post.shortcode}`)"
                  />
                </span>
                <span v-else>
                  <img
                    :src="post.imageUrl"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/content/${post.shortcode}`)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="instagramLinked==false">Please connect Instagram profile to view analytics.</div>
  <div v-else>
    <div class="lds-dual-ring"></div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import _ from "underscore";
import { mapGetters, mapActions } from "vuex";
import timeVars from "@/config/timeVars";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import LineChart from "@/components/UIComponents/Charts/LineChart";
import BarChart from "@/components/UIComponents/Charts/BarChart";
import PieChart from "@/components/UIComponents/Charts/PieChart";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";
import { VueDatamaps } from "vue-datamaps";
import VueApexCharts from "vue-apexcharts";
import { GChart } from "vue-google-charts";
import store from "@/store/index.js";
import Datepicker from "vuejs-datepicker";
import numeral from "numeral";

import {
  fbGraphInstagramInsights,
  clientProfileReadApi,
  userLoadApi,
  fbGraphMentionPosts,
  instagramPostApi,
  fbGraphInstagramCheck,
  instagramProfileAnalyticsApi,
  instagramPostAnalyticsApi,
  userRelatedProfilesApi
} from "@/config/appSettings";
const tooltipOptions = {
  tooltipFillColor: "rgba(0,0,0,0.5)",
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipFontSize: 14,
  tooltipFontStyle: "normal",
  tooltipFontColor: "#fff",
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipTitleFontSize: 14,
  tooltipTitleFontStyle: "bold",
  tooltipTitleFontColor: "#fff",
  tooltipYPadding: 6,
  tooltipXPadding: 6,
  tooltipCaretSize: 8,
  tooltipCornerRadius: 6,
  tooltipXOffset: 10
};

export default {
  name: "InstagramAnalytics",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    clientDetails: null,
    auth: null,
    getTime: null,
    insightChart: {},
    insightsLoaded: false,
    profileVisitsChart: {},
    followerChart: {},
    profileVisitsChartLoaded: false,
    websiteClicksChart: {},
    websiteClicksChartLoaded: false,
    websiteClicksTotal: 0,
    profileVisitsTotal: 0,
    impressionsTotal: 0,
    followersTotal: 0,
    reachTotal: 0,
    mentionsLoaded: false,
    mentionPostList: [],
    postList: [],
    loadingOverlay: false,
    loadingOverlayText: null,
    instagramLinked: null,
    genderSummary: null,
    genderSummaryChart: null,
    ageSummaryChart: null,
    ageSummaryApex: null,
    genderSummaryApex: null,
    countryChart: null,
    cityData: null,
    topPostList: [],
    analyticsData: null,
    postEngagementRate: null,
    postAvgLikes: null,
    postAvgComments: null,
    postCount: null,
    hashtagGeneralChart: null,
    hashtagRankedChart: null,
    activeInstagram: null,
    startDate: null,
    endDate: null,
    pickerStart: null,
    pickerEnd: null,
    postAnalyticsData: null,
    imageAnalyticsData: {
      postCount: null,
      avgComments: null,
      avgLikes: null,
      avgReach: null,
      totalReach: null,
      avgImpressions: null,
      totalImpressions: null,
      frequencyRatio: null,
      avgSaves: null,
      totalSaves: null,
      avgEngagementRate: null
    },
    videoAnalyticsData: {
      avgComments: null,
      avgLikes: null,
      avgReach: null,
      totalReach: null,
      avgImpressions: null,
      totalImpressions: null,
      frequencyRatio: null,
      avgSaves: null,
      totalSaves: null,
      avgEngagementRate: null
    },
    carouselAnalyticsData: {
      avgComments: null,
      avgLikes: null,
      avgReach: null,
      totalReach: null,
      avgImpressions: null,
      totalImpressions: null,
      frequencyRatio: null,
      avgSaves: null,
      totalSaves: null,
      avgEngagementRate: null
    },
    summaryAnalyticsData: {
      postCount: null,
      avgComments: null,
      avgLikes: null,
      avgReach: null,
      totalReach: null,
      avgImpressions: null,
      totalImpressions: null,
      frequencyRatio: null,
      avgSaves: null,
      totalSaves: null,
      avgEngagementRate: null
    },
    feedAnalyticsData: {
      postCount: null,
      avgComments: null,
      avgLikes: null,
      avgReach: null,
      totalReach: null,
      avgImpressions: null,
      totalImpressions: null,
      frequencyRatio: null,
      avgSaves: null,
      totalSaves: null,
      avgEngagementRate: null
    },
    storyAnalyticsData: {
      postCount: null,
      avgReach: null,
      totalReach: null,
      avgImpressions: null,
      totalImpressions: null,
      frequencyRatio: null
    }
  }),
  components: {
    ChartCard,
    LineChart,
    BarChart,
    PieChart,
    VueDatamaps,
    apexchart: VueApexCharts,
    GChart,
    StatsCard,
    Datepicker
  },
  created: function() {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  methods: {
    async checkNoAuthProfiles() {
      try {
        if (this.isTeam == true) {
          //console.log("ACTIVE INSTAGRAM:", this.activeInstagram);
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${this.activeInstagram}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
          return;
        }
        // console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (
          this.relatedProfileStore !== null &&
          typeof this.relatedProfileStore !== "undefined"
        ) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          // console.log("RESETTING PROFILES:", this.relatedProfiles);
          this.relatedProfileList = this.relatedProfiles.map(x => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async fullFeedAnalyticsButton() {
      let dateQuery = "";
      if (typeof this.$route.query.start !== "undefined") {
        let startDateUrl = this.$route.query.start;
        dateQuery = `?start=${startDateUrl}`;
      }
      if (typeof this.$route.query.end !== "undefined") {
        let endDateUrl = this.$route.query.end;
        if (dateQuery == "") {
          dateQuery = `?end=${endDate}`;
        } else {
          dateQuery = dateQuery + `&end=${endDateUrl}`;
        }
      }
      this.$router.push(
        `/instagram/analytics/feed/${this.$route.params.instagram}/${dateQuery}`
      );
    },
    async loadPostAnalytics() {
      try {
        let instagramPostAnalyticsUrl = `${instagramPostAnalyticsApi}/?instagram=${this.$route.params.instagram}&usertoken=${this.auth}&start=${this.startDate}&end=${this.endDate}`;
        // console.log("POST INSIGHT URL: ", instagramPostAnalyticsUrl);
        let instagramPostAnalyticsResponse = await axios.get(
          instagramPostAnalyticsUrl
        );
        if (instagramPostAnalyticsResponse.data.success == true) {
          this.insightsLoaded = true;

          this.postAnalyticsData = instagramPostAnalyticsResponse.data.result;
          //console.log("POST ANALYTICS:", this.postAnalyticsData);
          if (
            typeof instagramPostAnalyticsResponse.data.result.topFeedPosts !==
            "undefined"
          ) {
            let topFeedPostList = this.postAnalyticsData.topFeedPosts;
            if (topFeedPostList.length > 0) {
              this.topPostList = topFeedPostList.slice(0, 7);

              if (this.postAnalyticsData.postTypes.feed.summary.posts > 0) {
                this.postEngagementRate =
                  (
                    this.postAnalyticsData.postTypes.feed.summary
                      .avgEngagementRate * 100
                  ).toFixed(2) + "%";

                this.postAvgLikes = String(
                  this.postAnalyticsData.postTypes.feed.summary.avgLikes.toFixed()
                );
                this.postAvgComments = String(
                  this.postAnalyticsData.postTypes.feed.summary.avgComments.toFixed()
                );
              }

              if (this.postAnalyticsData.postTypes.feed.summary.posts > 0) {
                this.postEngagementRate =
                  String(
                    (
                      this.postAnalyticsData.postTypes.feed.summary
                        .avgEngagementRate * 100
                    ).toFixed(2)
                  ) + "%";

                this.postAvgLikes = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgLikes
                ).format("0,0");
                this.postAvgComments = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgComments
                ).format("0,0");
              }

              this.feedPpostCount = numeral(
                this.postAnalyticsData.postCount
              ).format("0,0");

              if (this.postAnalyticsData.postTypes.feed.summary.posts > 0) {
                this.summaryAnalyticsData.avgComments = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgComments
                ).format("0,0");
                this.summaryAnalyticsData.avgLikes = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgLikes
                ).format("0,0");
                this.summaryAnalyticsData.avgReach = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgReach
                ).format("0,0");

                this.summaryAnalyticsData.avgImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgImpressions
                ).format("0,0");
                this.summaryAnalyticsData.avgSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgSaves
                ).format("0,0");
                this.summaryAnalyticsData.totalSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.totalSaves
                ).format("0,0");
                this.summaryAnalyticsData.postCount = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.posts
                ).format("0,0");
                this.summaryAnalyticsData.totalReach = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.totalReach
                ).format("0,0");
                this.summaryAnalyticsData.totalImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.totalImpressions
                ).format("0,0");
                this.summaryAnalyticsData.irRatio = String(
                  this.postAnalyticsData.postTypes.feed.summary.irRatio.toFixed(
                    2
                  )
                );
                this.summaryAnalyticsData.avgEngagementRate = String(
                  (
                    this.postAnalyticsData.postTypes.feed.summary
                      .avgEngagementRate * 100
                  ).toFixed(2)
                );
              }

              if (this.postAnalyticsData.postTypes.feed.image.totalPosts > 0) {
                this.imageAnalyticsData.postCount = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.posts
                ).format("0,0");
                this.imageAnalyticsData.avgComments = numeral(
                  this.postAnalyticsData.postTypes.feed.image.avgComments
                ).format("0,0");
                this.imageAnalyticsData.avgLikes = numeral(
                  this.postAnalyticsData.postTypes.feed.image.avgLikes
                ).format("0,0");
                this.imageAnalyticsData.avgReach = numeral(
                  this.postAnalyticsData.postTypes.feed.image.avgReach
                ).format("0,0");

                this.imageAnalyticsData.avgImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.image.avgImpressions
                ).format("0,0");
                this.imageAnalyticsData.avgSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.image.avgSaves
                ).format("0,0");
                this.imageAnalyticsData.totalSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.image.totalSaves
                ).format("0,0");
                this.imageAnalyticsData.totalReach = numeral(
                  this.postAnalyticsData.postTypes.feed.image.totalReach
                ).format("0,0");
                this.imageAnalyticsData.totalImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.image.totalImpressions
                ).format("0,0");
                this.imageAnalyticsData.irRatio = String(
                  this.postAnalyticsData.postTypes.feed.image.irRatio.toFixed(2)
                );
                this.imageAnalyticsData.avgEngagementRate = String(
                  (
                    this.postAnalyticsData.postTypes.feed.image
                      .avgEngagementRate * 100
                  ).toFixed(2)
                );
              }
              if (this.postAnalyticsData.postTypes.feed.video.totalPosts > 0) {
                this.videoAnalyticsData.avgComments = numeral(
                  this.postAnalyticsData.postTypes.feed.video.avgComments
                ).format("0,0");
                this.videoAnalyticsData.avgLikes = numeral(
                  this.postAnalyticsData.postTypes.feed.video.avgLikes
                ).format("0,0");
                this.videoAnalyticsData.avgReach = numeral(
                  this.postAnalyticsData.postTypes.feed.video.avgReach
                ).format("0,0");

                this.videoAnalyticsData.avgImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.video.avgImpressions
                ).format("0,0");
                this.videoAnalyticsData.avgSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.video.avgSaves
                ).format("0,0");
                this.videoAnalyticsData.totalSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.video.totalSaves
                ).format("0,0");
                this.videoAnalyticsData.totalReach = numeral(
                  this.postAnalyticsData.postTypes.feed.video.totalReach
                ).format("0,0");
                this.videoAnalyticsData.totalImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.video.totalImpressions
                ).format("0,0");
                this.videoAnalyticsData.irRatio = this.postAnalyticsData.postTypes.feed.video.irRatio.toFixed(
                  2
                );
                this.videoAnalyticsData.avgEngagementRate = String(
                  (
                    this.postAnalyticsData.postTypes.feed.video
                      .avgEngagementRate * 100
                  ).toFixed(2)
                );
              }
              if (
                this.postAnalyticsData.postTypes.feed.carousel.totalPosts > 0
              ) {
                this.carouselAnalyticsData.avgComments = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.avgComments
                ).format("0,0");
                this.carouselAnalyticsData.avgLikes = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.avgLikes
                ).format("0,0");
                this.carouselAnalyticsData.avgReach = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.avgReach
                ).format("0,0");

                this.carouselAnalyticsData.avgImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.avgImpressions
                ).format("0,0");
                this.carouselAnalyticsData.avgSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.avgSaves
                ).format("0,0");
                this.carouselAnalyticsData.totalSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.totalSaves
                ).format("0,0");
                this.carouselAnalyticsData.totalReach = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel.totalReach
                ).format("0,0");
                this.carouselAnalyticsData.totalImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.carousel
                    .totalImpressions
                ).format("0,0");
                this.carouselAnalyticsData.irRatio = String(
                  this.postAnalyticsData.postTypes.feed.carousel.irRatio.toFixed(
                    2
                  )
                );
                this.carouselAnalyticsData.avgEngagementRate = String(
                  (
                    this.postAnalyticsData.postTypes.feed.carousel
                      .avgEngagementRate * 100
                  ).toFixed(2)
                );
              }
              if (this.postAnalyticsData.postTypes.stories.summary.posts > 0) {
                this.storyAnalyticsData.postCount = numeral(
                  this.postAnalyticsData.postTypes.stories.summary.posts
                ).format("0,0");

                this.storyAnalyticsData.avgReach = numeral(
                  this.postAnalyticsData.postTypes.stories.summary.avgReach
                ).format("0,0");

                this.storyAnalyticsData.avgImpressions = numeral(
                  this.postAnalyticsData.postTypes.stories.summary
                    .avgImpressions
                ).format("0,0");
                this.storyAnalyticsData.avgSaves = numeral(
                  this.postAnalyticsData.postTypes.stories.summary.avgSaves
                ).format("0,0");
                this.storyAnalyticsData.totalSaves = numeral(
                  this.postAnalyticsData.postTypes.stories.summary.totalSaves
                ).format("0,0");
                this.storyAnalyticsData.totalReach = numeral(
                  this.postAnalyticsData.postTypes.stories.summary.totalReach
                ).format("0,0");
                this.storyAnalyticsData.totalImpressions = numeral(
                  this.postAnalyticsData.postTypes.stories.summary
                    .totalImpressions
                ).format("0,0");
                //console.log("STORY ANALYTICS CHECK:", this.storyAnalyticsData);
                this.storyAnalyticsData.irRatio = String(
                  this.postAnalyticsData.postTypes.stories.summary.irRatio.toFixed(
                    2
                  )
                );
              }
              if (this.postAnalyticsData.postTypes.feed.summary.posts > 0) {
                this.feedAnalyticsData.postCount = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.posts
                ).format("0,0");

                this.feedAnalyticsData.avgReach = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgReach
                ).format("0,0");

                this.feedAnalyticsData.avgImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgImpressions
                ).format("0,0");
                this.feedAnalyticsData.avgSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgSaves
                ).format("0,0");
                this.feedAnalyticsData.totalSaves = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.totalSaves
                ).format("0,0");
                this.feedAnalyticsData.totalReach = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.totalReach
                ).format("0,0");
                this.feedAnalyticsData.totalImpressions = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.totalImpressions
                ).format("0,0");
                this.feedAnalyticsData.irRatio = String(
                  this.postAnalyticsData.postTypes.feed.summary.irRatio.toFixed(
                    2
                  )
                );
                this.feedAnalyticsData.avgComments = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgComments
                ).format("0,0");
                this.feedAnalyticsData.avgLikes = numeral(
                  this.postAnalyticsData.postTypes.feed.summary.avgLikes
                ).format("0,0");
                this.feedAnalyticsData.avgEngagementRate = String(
                  (
                    this.postAnalyticsData.postTypes.feed.summary
                      .avgEngagementRate * 100
                  ).toFixed(2)
                );
              }
              //console.log("FEED ANALYTICS: ", this.feedAnalyticsData);

              // HASHTAG ANALYTICS

              try {
                if (this.postAnalyticsData.hashtags.hashtagsUsed.length > 0) {
                  this.hashtagGeneralChart = {};
                  this.hashtagGeneralChart.options = {
                    chart: {
                      id: "Avg Hashtags",
                      toolbar: {
                        show: false
                      }
                    },
                    yaxis: {
                      labels: {
                        formatter: function(value) {
                          return value.toFixed(1);
                        }
                      },
                      tickAmount: 2
                    },
                    xaxis: {
                      categories: ["hashtags used", "hashtags ranked"]
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false
                      }
                    },
                    dataLabels: {
                      enabled: false
                    }
                  };
                  this.hashtagGeneralChart.series = [
                    {
                      name: "average",
                      data: [
                        this.postAnalyticsData.hashtags.avgUsed.toFixed(2),
                        this.postAnalyticsData.hashtags.avgRanked.toFixed(2)
                      ]
                    }
                  ];
                  // SORT
                  let rankedHashtags = _.sortBy(
                    this.postAnalyticsData.hashtags.hashtagsRanked,
                    "count"
                  ).reverse();

                  rankedHashtags = rankedHashtags.slice(0, 5);

                  let rankedHashtagLabels = rankedHashtags.map(x => {
                    return x.hashtag;
                  });
                  let rankedHashtagCounts = rankedHashtags.map(x => {
                    return x.count;
                  });
                  this.hashtagRankedChart = {};
                  this.hashtagRankedChart.options = {
                    chart: {
                      id: "Ranked",
                      toolbar: {
                        show: false
                      }
                    },

                    yaxis: {},
                    xaxis: {
                      categories: rankedHashtagLabels,
                      tickAmount: 2,
                      allowDecimals: false,
                      formatter: function(value) {
                        return value.toFixed();
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: true
                      }
                    },
                    dataLabels: {
                      enabled: false
                    }
                  };
                  this.hashtagRankedChart.series = [
                    {
                      name: "total",
                      data: rankedHashtagCounts
                    }
                  ];
                }
              } catch (err) {
                //console.log("ERROR", err);
              }
            }
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async formatDate(dateInput) {
      let thisDate = moment(dateInput).format("yyyy-MM-DD");
      console.log("THIS DATE:", thisDate);
    },
    async resetDates() {
      //console.log("START DATE", this.pickerStart);
      let startDateString = new Date(this.pickerStart); // Your timezone!
      this.startDate = startDateString.getTime() / 1000;
      //console.log("START TIMESTAMP: ", this.startDate);
      //console.log("END DATE", this.pickerEnd);
      let endDateString = new Date(this.pickerEnd); // Your timezone!
      this.endDate = endDateString.getTime() / 1000;
      //console.log("END TIMESTAMP: ", this.endDate);
      if (this.startDate < this.endDate) {
        let startDateUrl = moment
          .unix(this.startDate)
          .startOf("day")
          .format("YYYY-MM-DD");
        let endDateUrl = moment
          .unix(this.endDate)
          .endOf("day")
          .format("YYYY-MM-DD");
        this.analyticsData = null;

        await this.loadPostAnalytics();
        if (
          startDateUrl == this.$route.query.start &&
          endDateUrl == this.$route.query.end
        ) {
          return;
        }

        this.$router.push(
          `/instagram/analytics/content/${this.$route.params.instagram}/?start=${startDateUrl}&end=${endDateUrl}`
        );
      }
    },
    async loadRecentPosts() {
      try {
        let instagramPostResponse = await axios.get(
          `${instagramPostApi}/?usertoken=${this.auth}&instagram=${this.activeInstagram}`
        );

        //console.log("POST LIST :", instagramPostResponse.data);

        if (instagramPostResponse.data.success === true) {
          //console.log("SETTING POST LIST:");

          this.postList = instagramPostResponse.data.result.slice(0, 7);
          //this.filterList("feed");
          //console.log("POST LIST SET:", this.postList);
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },

    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (
          this.relatedProfileStore == null ||
          typeof this.relatedProfileStore == "undefined"
        ) {
          let relatedProfileUrl = `${userRelatedProfilesApi}/?usertoken=${this.auth}`;
          //console.log("RELATED PROFILE URL:", relatedProfileUrl);
          let relatedProfileResponse = await axios.get(relatedProfileUrl);
          this.relatedProfiles = relatedProfileResponse.data.result;
          store.dispatch(
            "storeRelatedProfiles",
            relatedProfileResponse.data.result
          );
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async setProfileType() {
      //console.log("PROFILE STORE:", this.profileStore);
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },

    async loadPageContent() {
      await this.setProfileType();
      await this.getRelatedProfiles();
      this.getTime = await timeVars.timeInfo();
      //console.log("UTC TIME:", this.getTime.utcTime);

      this.endDate =
        moment
          .unix(this.getTime.utcTime)
          .startOf("day")
          .utc() / 1000;
      this.startDate =
        moment
          .unix(this.endDate)
          .utc()
          .subtract(7, "days") / 1000;

      //console.log("GENERIC START DATE:", this.startDate);
      //console.log("GENERIC END DATE:", this.endDate);

      this.pickerStart = new Date(this.startDate * 1000);
      if (typeof this.$route.query.start !== "undefined") {
        let startTs =
          moment(this.$route.query.start)
            .utc()
            .valueOf() / 1000;
        //console.log("START TS:", startTs);
        if (!isNaN(startTs)) {
          this.startDate = startTs;
          this.pickerStart = new Date(startTs * 1000);
          //console.log("PICKER START:", this.pickerStart);
        }
      }
      this.pickerEnd = new Date(this.endDate * 1000);
      if (typeof this.$route.query.end !== "undefined") {
        let endTs =
          moment(this.$route.query.end)
            .utc()
            .valueOf() / 1000;
        //console.log("END TS:", endTs);
        if (!isNaN(endTs)) {
          this.endDate = endTs;
          this.pickerEnd = new Date(this.endDate * 1000);
          //console.log("PICKER END:", this.pickerEnd);
        }
      }

      if (this.isClient == true) {
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }
      if (this.isInfluencer == true) {
        if (this.relatedProfiles !== null) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }

      if (this.isTeam == true) {
        this.activeInstagram = this.$route.params.instagram;
      }

      await this.checkNoAuthProfiles();

      //console.log("LINKED INSTAGRAM:", this.instagramLinked);
      if (this.instagramLinked == true) {
        this.loadPostAnalytics();
      }
      await this.loadRecentPosts();
      this.loadingOverlay = false;
    }
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  }
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
</style>